<template>
  <div id="analyticsMatrix" :myProjectsSearchId="myProjectsSearchId">
    <div class="leftBox">
      <h1 class="user">{{ $t('appAnalysis.echarts.sidebar.user') }}</h1>
      <ul class="navMatrix">
        <li @click="textSelectClick('download')" class="textSelect">
          <span>{{ $t('appAnalysis.echarts.common.downloads') }}</span>
        </li>
        <li :style="cursorNo">
          <span>{{ $t('appAnalysis.echarts.sidebar.install') }}</span>
        </li>
        <li :style="cursorNo">
          <span>{{ $t('appAnalysis.echarts.sidebar.uninstall') }}</span>
        </li>
      </ul>
    </div>
    <div style="width:990px;margin-left:18px;">
      <div style="margin-top:18px;">
        <el-row>
          <el-col :span="24">
            <div class="_div">
              <h1 class="times">{{ sumAll }}</h1>
              <ul
                class="_ul"
                :style="!ischoose ? 'position: absolute;right:0px;' : 'position: absolute;right:94px;'"
              >
                <li
                  @click="clickLiColor('0', 'week')"
                  :class="{ liBackColor: isLiBackColor === '0' }"
                >過去 7 天</li>
                <li
                  @click="clickLiColor('1', 'month')"
                  :class="{ liBackColor: isLiBackColor === '1' }"
                >過去 30 天</li>
                <li
                  @click="clickLiColor('2', 'year')"
                  :class="{ liBackColor: isLiBackColor === '2' }"
                >過去 1 年</li>
                <li>
                  <div class="block" :class="{blockChose: ischoose === true}">
                    <el-date-picker
                      v-model="value6"
                      format="MM月dd日"
                      :type="daterange"
                      @focus="pickerFunc"
                      @blur="blurFunc"
                      ref="picker"
                      :editable="false"
                    ></el-date-picker>
                  </div>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <!-- </div> -->
        <h1 class="downloadTimes">{{ $t('appAnalysis.echarts.common.downloads') }}</h1>
      </div>
      <div id="myChart" ref="myChart"></div>
      <el-main>
        <el-table
          :data="datelist"
          @row-click="rowClick"
          :cell-style="cellStyle"
          :header-cell-style="headerStyle"
          style="width: 100%"
        >
          <el-table-column
            :default-sort="{prop: 'day', order: 'descending'}"
            sortable
            :label="$t('appAnalysis.echarts.table.header.date')"
            prop="day"
          ></el-table-column>

          <el-table-column :label="$t('appAnalysis.echarts.common.downloads')" prop="sum"></el-table-column>
        </el-table>
      </el-main>
    </div>
  </div>
</template>
<style>
#analyticsMatrix .el-table th > .cell {
    height: 40px;
    line-height: 40px;
}
#analyticsMatrix .el-table th {
    padding: 0px;
}
#analyticsMatrix .el-table thead {
    width: 234px;
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    text-align: right;
    color: #333333;
}
#analyticsMatrix .el-main {
    padding: 0px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    margin-bottom: 100px;
    border-bottom: none;
}
#analyticsMatrix .el-table th.is-leaf,
.el-table td {
    height: 40px;
}
#analyticsMatrix .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
}
#analyticsMatrix .el-table th.is-leaf,
.el-table td {
    border-bottom: 1px solid rgba(31, 31, 31, 0.1);
}
#analyticsMatrix .el-table .caret-wrapper {
    margin-left: 48px;
}
#analyticsMatrix .el-range-editor.el-input__inner {
    width: 100%;
    border-top-left-radius: inherit;
    height: 40px;
    vertical-align: middle;
    border-bottom-left-radius: inherit;
}
</style>

<style scoped>
ul {
    padding: 0px;
    margin: 0px;
}
li {
    list-style: none;
}
h1 {
    margin: 0px;
}
.textSelect {
    color: #00b5e2;
    font-weight: 500;
}
#myChart {
    width: 100%;
    height: 290px;
    font-size: 12px;
    color: red !important;
}
.leftBox {
    width: 175px;
    box-shadow: 1px 0 0 0 rgba(0, 181, 226, 0.3);
    background-color: rgba(0, 181, 226, 0.05);
    padding: 30px 0px 0px 30px;
    box-sizing: border-box;
}
#analyticsMatrix {
    display: flex;
}
.user {
    width: 135px;
    height: 20px;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
    margin-bottom: 10px;
}
.navMatrix {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.7px;
    color: #333333;
}
.navMatrix > li {
    margin-left: 10px;
    padding: 5px 10px;
    cursor: pointer;
}
.times {
    width: 346px;
    height: 59px;
    font-family: sans-serif;
    font-size: 40px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 2.2px;
    color: #333333;
    display: inline-block;
    text-align: left;
}
.downloadTimes {
    width: 346px;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
}
#analyticsMatrix .liBackColor {
    background-color: #00b5e2;
    color: #ffffff;
}
._div {
    text-align: right;
    display: flex;
    line-height: 56px;
    justify-content: space-between;
    margin-top: 17px;
}
.liPickerDate {
    list-style: none;
    display: inline-block;
    width: 80px;
    text-align: center;
}
.block {
    width: 111px;
    position: relative;
    right: 0px;
}
._ul li {
    width: 111px;
    height: 38px;
    background-color: #ffffff;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-right: none;
    line-height: 36px;
    cursor: pointer;
    display: inline-block;
    text-align: center;
}
._ul li:nth-child(1) {
    border-top-left-radius: 4px;

    border-bottom-left-radius: 4px;
}
._ul li:nth-child(4) {
    border-left: none;
    border-top: none;
}
.blockChose {
    width: 205px;
}
</style>
<script>
// 引入完整的echarts
import echarts from 'echarts'
import moment from 'moment'
export default {
    data () {
        return {
            cursorNo:
                'cursor:not-allowed;color:#333333;opacity:.5;font-weight:normal;',
            Max: null,
            arrlist: null,
            datelist: [],
            data: [],
            isTextClass: '',
            tableData: [],
            appId: '',
            ischoose: false,
            elIconDate: ' ',
            isLiBackColor: '',
            value6: '',
            daterange: 'daterange',
            sumAll: ''
        }
    },
    mounted () {
        let secondNavItem = [
            { path: 'overView', msg: 'header.secondFloor.route.name.overview' },
            true,
            { path: 'echarts', msg: 'header.secondFloor.route.name.detailAnalysis' }
        ]
        this.$store.state.secondNavItem = secondNavItem
        // 调用绘制图表的方法
        if (sessionStorage.getItem('appId')) {
            this.$store.state.appId = sessionStorage.getItem('appId')
        }
        // 获取数据
        if (this.$refs.picker) {
            this.$store.state.pickerDom = this.$refs.picker
        }
        // 默认七天
        this.clickLiColor('0', 'week')
    },
    computed: {
        myProjectsSearchId () {
            let { key } = this.$store.state.myProjectsSearchId
            if (key === 'appAnalysis') {
                this.clickLiColor('0', 'week')
            }
            return this.$store.state.myProjectsSearchId
        }
    },
    methods: {
        draw () {
            let myChart = echarts.init(this.$refs.myChart)
            // 绘制条形图
            myChart.setOption({
                // 控制内容得padding
                grid: {
                    x: 70,
                    y: 40,
                    x2: 50,
                    y2: 66,
                    borderWidth: 1,
                    borderColor: '#dedede'
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: (param, ticket, callback) => {
                        // 用定时器模拟异步事件
                        setTimeout(function () {
                            var res = `<div>
              <p style="padding:0px;margin:0px;">${moment(param[0].name).format(
        'YYYY年MM月DD日'
    )}</p>
              <p style="padding:0px;margin:0px;">下载${param[0].value[1]}次</p>
              </div>`
                            callback(ticket, res)
                        }, 500)
                        return 'loading' // 内容还没返回时显示的内容
                    },
                    textStyle: {
                        align: 'left',
                        // 提示框颜色
                        color: '#333333',
                        fontFamily: 'NotoSansCJKtc',
                        fontSize: 12
                        // color:'rgba(0, 224, 218, 0.3)'
                    },
                    // 提示框背景色
                    backgroundColor: '#FFFFFF',
                    // 提示框的边框
                    borderWidth: 1,
                    // 提示框的边框色
                    borderColor: '#d6d6d6',
                    // 提示框 内边距
                    padding: [3, 5],
                    // 这是那根标尺线 样式
                    position: function (point, params, dom) {
                        // point[0] // x轴：- 往左 + 往右
                        // point[1] // y轴：- 往上 + 往下
                        return [point[0] - 25, point[1] + 20]
                    },
                    axisPointer: {
                        type: 'line',
                        lineStyle: {
                            // color: "hsla(240, 0%, 50%, 0.3)",
                            // 这是标识杆的颜色
                            color: 'rgba(0, 224, 218, 0.3)',
                            width: 2,
                            type: 'solid'
                        }
                    }
                },
                // X轴
                xAxis: {
                    type: 'time',
                    // data: this.datelist,
                    splitLine: {
                        show: false
                    },
                    // x轴的样式
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#333333',
                            width: 1
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            // x轴字体颜色
                            color: '#333333',
                            fontSize: 12,
                            fontFamily: 'NotoSansCJKtc',
                            fontWeight: 300,
                            fontStyle: 'normal',
                            letterSpacing: 0.8
                        },
                        interval: 0,
                        formatter: function (value, index) {
                            var date = new Date(value)
                            var texts = [date.getMonth() + 1, date.getDate()]
                            return texts.join('/')
                        }
                    }
                    // 改变坐标轴的样式
                },
                // Y轴
                yAxis: {
                    type: 'value',
                    max: this.Max, // 计算最大值
                    interval: Math.ceil(this.Max / 5),
                    // scale: true,
                    splitLine: {
                        show: true,
                        lineStyle: { type: 'dashed' }
                    },
                    axisLine: {
                        show: false
                    },
                    axisLabel: {
                        fontSize: 12,
                        fontFamily: 'NotoSansCJKtc',
                        fontWeight: 300,
                        fontStyle: 'normal',
                        letterSpacing: 0.7,
                        color: 'rgba(51, 51, 51, 0.5)'
                    },
                    axisTick: {
                        show: false
                    }
                },
                // 数据
                series: [
                    {
                        type: 'line',
                        data: this.tableData,
                        showSymbol: true,
                        symbol: 'circle', // 实心点
                        symbolSize: p => {
                            if (parseInt(p[1]) > 0) {
                                return 5
                            } else {
                                return 0
                            }
                        }, // 实心点大小
                        // 实心点的颜色
                        itemStyle: {
                            normal: {
                                color: '#00b5e2',
                                // 折线的样式
                                lineStyle: { color: '#00b5e2', width: 1.6 }
                            }
                        }
                    }
                ]
            })
        },
        textSelectClick (type) {
            this.isTextClass = type
        },
        rowClick (row) {
        },
        cellStyle ({ row, column, rowIndex, columnIndex }) {
            // console.log(rowIndex)
            if (columnIndex === 1) {
                return `
          text-align:right;
          padding-right:20px!important;
          `
            } else {
                return `
          padding-left:20px!important;
          `
            }
        },
        headerStyle ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1) {
                return `
          text-align:right;
          padding-right:20px!important;
          `
            } else {
                return `
          padding-left:20px!important;
          `
            }
        },
        getData (type, obj) {
            let path
            if (this.$route.query.appId) {
                this.appId = this.$route.query.appId
                this.$store.state.appId = this.appId
            } else {
                this.appId = this.$store.state.appId
            }
            if (type && obj) {
                const { beginDate, endDate } = obj
                path = `/developer/${
                    this.appId
                }/downloadLine/report?beginDate=${beginDate}&endDate=${endDate}`
            } else {
                path = `/developer/${
                    this.appId
                }/downloadLine/report`
            }

            this._api.request('get', path)
                .then(res => {
                    if (res.status === 200) {
                        this.tableData = res.data.data.payload
                        this.datelist = res.data.data.payload
                        this.tableData = this.tableData.map((item, index) => {
                            if (index % 20 === 1) {
                                return {
                                    name: item.day,
                                    value: [item.day, index * index]
                                }
                            }
                            return {
                                name: item.day,
                                value: [item.day, item.sum]
                            }
                        })
                        this.datelist = this.datelist.map(o => {
                            if (o.day) {
                                o.day = moment(o.day).format('YYYY 年 MM 月 DD 日')
                            }
                            return o
                        })
                        this.data = this.tableData.map(item => {
                            return parseInt(item.value[1])
                        })
                        this.sumAll = this.data.reduce((o, n) => o + n)
                        this.Max = Math.max.apply(null, this.data)
                        this.draw()
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },
        pickerStyle (type, flag) {
            let dom = this.$store.state.pickerDom.$el
            let childNodes = dom.childNodes
            var display
            var color
            var backColor
            if (type === 0) {
                display = 'none'
                if (childNodes.length < 6) {
                    let span = document.createElement('span')
                    span.innerText = '自訂範圍'
                    span.style.marginLeft = '11px'
                    dom.appendChild(span)
                }
                if (flag) {
                    color = '#333'
                    backColor = '#fff'
                } else {
                    color = '#fff'
                    backColor = '#00b5e2'
                }
                childNodes[5].style.backgroundColor = backColor
                childNodes[5].style.color = color
                childNodes[5].style.lineHeight = '38px'
                childNodes[5].style.display = 'block'
            } else {
                display = 'block'
                backColor = '#00b5e2'
                childNodes[0].style.color = '#fff'
                childNodes[1].style.backgroundColor = '#00b5e2'
                childNodes[1].style.color = '#fff'
                childNodes[2].style.color = '#fff'
                childNodes[2].style.width = '10px'
                childNodes[3].style.backgroundColor = '#00b5e2'
                childNodes[3].style.color = '#fff'
                childNodes[4].style.color = '#fff'
                if (childNodes.length === 6) {
                    childNodes[5].style.display = 'none'
                }
            }
            for (let i = 0; i < 5; i++) {
                childNodes[i].style.display = display
            }
            dom.style.backgroundColor = backColor
        },
        // 选择日期
        clickLiColor (type, time) {
            this.isLiBackColor = type
            this.pickerStyle(0, true)
            this.value6 = ''
            let dateObj = this.computedDate(time)
            this.getData(1, dateObj)
        },
        pickerFunc () {
            this.ischoose = true
            this.isLiBackColor = null
            this.elIconDate = 'el-icon-date'
        },
        blurFunc () {
            if (!this.value6) {
                this.ischoose = false
                this.elIconDate = ' '
            } else {
                let beginDate, endDate
                for (let i = 0; i < this.value6.length; i++) {
                    if (i === 0) {
                        beginDate = this.momentFunc(this.value6[i])
                    } else {
                        endDate = this.momentFunc(this.value6[i])
                    }
                }
                this.getData(1, { beginDate, endDate })
            }
        },
        // 转换时间
        momentFunc (date, type) {
            if (!date) {
                return
            }
            if (type) {
                return moment(date).format('YYYY-MM-DD')
            }
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        computedDate (type, val) {
            let endDate = this.momentFunc(new Date())
            let beginDate
            if (type === 'week') {
                beginDate = this.momentFunc(
                    new Date(new Date() - 6 * 24 * 3600 * 1000)
                )
                return { beginDate, endDate }
            } else if (type === 'month') {
                beginDate = this.momentFunc(
                    new Date(new Date() - 29 * 24 * 3600 * 1000)
                )
                return { beginDate, endDate }
            } else {
                beginDate = this.momentFunc(
                    new Date().setFullYear(new Date().getFullYear() - 1)
                )
                return { beginDate, endDate }
            }
        }
    },
    beforeUpdate () {
        // 切换日期选择器的样式
        if (!this.value6) {
            this.ischoose = false
            this.elIconDate = ' '
            this.pickerStyle(0)
        } else if (this.value6) {
            this.ischoose = true
            this.elIconDate = 'el-icon-date'
            this.pickerStyle(1)
        }
        if (this.isLiBackColor) {
            this.pickerStyle(0, true)
        }
    },
    destroyed () {
        this.$store.state.appId = this.appId
    }
}
</script>
